import React from "react";
import WiresActivityPage from "components/pages/WiresActivityPage";

/**
 * @name Capture001WireActivity
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Activity".
 */
export default function Capture001WireActivity() {
    return <WiresActivityPage />;
}